import './ProductList.scss';
import icons from '../../../shared/assets/icons';
import { getString } from '../../../helpers/styles';

const { Star, ShoppingCart } = icons;

export default function ProductList({ useQuery, getListQuery, listName }) {
  const { data } = useQuery(getListQuery, { variables: { name: listName } });

  const items = (data?.getList?.items || []).filter((item) => item?.product);

  if (!items.length) return;

  return (
    <ul className="productList">
      {items.map(({ id, imageUrl, title, product }) => (
        <li className="productList-item" key={id}>
          <img
            className="productList-item-img"
            src={imageUrl}
            alt="product-image"
          />

          <div className="productList-item-primary-info">
            <div>
              <h5 className="productList-item-title">{title}</h5>

              <div className="productList-item-rating">
                {Array.from({ length: 5 }).map((_, idx) => (
                  <span
                    className={getString([
                      {
                        value: 'productList-item-star-icon',
                        condition: true
                      },
                      {
                        value: 'productList-item-star-icon-filled',
                        condition: idx < +product.rating
                      }
                    ])}
                    key={idx}
                  >
                    <Star />
                  </span>
                ))}
              </div>
            </div>

            <span className="productList-item-price">€ {product.price}</span>
          </div>

          <div className="productList-item-secondary-info">
            <p className="productList-item-supplier">
              Aangeboden door <br />
              <span>{product.supplier}</span> -{' '}
              {'\u20AC'.repeat(product.priceLevel)}
            </p>

            <a
              target="_blank"
              className="productList-item-link cursor-pointer"
              rel="noopener noreferrer"
              href={product.shopUrl}
            >
              <ShoppingCart />
              Bekijk product
            </a>
          </div>

          <div
            className="productList-item-benefits"
            dangerouslySetInnerHTML={{
              __html: (product.prosAndCons || '')
                .replaceAll('+', '<br /><span>+</span>')
                .replaceAll('-', '<br /><span>-</span>')
            }}
          />
        </li>
      ))}
    </ul>
  );
}
